import { AxiosResponse } from 'axios';
import api from '~/services/api';
import { CommissionReportData } from './commission-report-interface';
import { UserInterface } from '@e3labs/isa-data-dictionary';
import { FilterFormValues } from '~/store/modules/commission-report/commission-report-interface';
import { startOfDay, endOfDay, format } from 'date-fns';

class CommissionReportServices {
  getListSuccessCommissionReports(
    { skip = 0, limit = 10, ...rest },
    opts?: any
  ): Promise<AxiosResponse<CommissionReportData[] | null>> {
    return api.get('/user/commission-report-json', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }
  getCommissionReportDetails({ ...rest }): Promise<AxiosResponse<CommissionReportData[] | null>> {
    return api.get('/user/commission-details-report-json', {
      params: {
        ...rest
      }
    });
  }

  getSuccessRowCount({ skip = 0, limit = 10, ...rest }, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/user/commission-report-json?isCount=true', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getCSVSuccessCommissionReports({ ...rest }): Promise<AxiosResponse<any[] | null>> {
    return api.get('/user/commission-report-csv', {
      headers: {
        'Content-Disposition': 'attachment; filename=report.csv',
        'Content-Type': 'text/csv'
      },
      responseType: 'arraybuffer',
      params: {
        ...rest
      }
    });
  }

  getCSVSuccessCommissionReportsDetails({ ...rest }): Promise<AxiosResponse<any[] | null>> {
    return api.get('/user/commission-details-report-csv', {
      headers: {
        'Content-Disposition': 'attachment; filename=report.csv',
        'Content-Type': 'text/csv'
      },
      responseType: 'arraybuffer',
      params: {
        ...rest
      }
    });
  }
  getXslxSuccessCommissionReports(): Promise<AxiosResponse<any[] | null>> {
    return api.get('/user/commission-report/report-xlsx', {
      headers: {
        'Content-Disposition': 'attachment; filename=report.xlsx',
        'Content-Type': 'application/vnd.ms-excel'
      },
      responseType: 'arraybuffer'
    });
  }
  formatPeriodsParams(filters?: FilterFormValues) {
    const DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss';
    return {
      liquidityPeriodStartDate: filters?.liquidityPeriod
        ? format(new Date(filters.liquidityPeriod[0]), DATE_FORMAT)
        : undefined,

      liquidityPeriodEndDate: filters?.liquidityPeriod
        ? format(endOfDay(new Date(filters.liquidityPeriod[1])), DATE_FORMAT)
        : undefined,

      billedPeriodStartDate: filters?.billedPeriod ? format(new Date(filters.billedPeriod[0]), DATE_FORMAT) : undefined,

      billedPeriodEndDate: filters?.billedPeriod
        ? format(endOfDay(new Date(filters.billedPeriod[1])), DATE_FORMAT)
        : undefined,
      paymentCommissionDate: filters?.paymentCommissionDate
        ? format(startOfDay(new Date(filters.paymentCommissionDate)), DATE_FORMAT)
        : undefined
    };
  }
}

export default new CommissionReportServices();
